/* eslint-disable react/no-array-index-key */
import React from 'react';
import { classNames } from 'primereact/utils';
import AUIDropdownField from '@ancert/aui-dropdown-field';
import AUIInputTextField from '@ancert/aui-input-text-field';
import AUIInputTextAreaField from '@ancert/aui-input-textarea-field';

const getFieldComponent = ({ index, type, required, placeholder, label, options, validations, control, formState }) => {
  if (type === 'dropdown') {
    return (
      <AUIDropdownField
        required={required}
        placeholder={placeholder}
        name={`dropdown-${index}`}
        label={label}
        controlRef={control}
        errors={formState.errors}
        options={options}
        appendTo={null}
      />
    );
  }
  if (type === 'inputText') {
    return (
      <AUIInputTextField
        required={required}
        placeholder={placeholder}
        name={`inputText-${index}`}
        label={label}
        controlRef={control}
        errors={formState.errors}
      />
    );
  }
  if (type === 'textArea') {
    return (
      <AUIInputTextAreaField
        required={required}
        placeholder={placeholder}
        name={`textArea-${index}`}
        label={label}
        controlRef={control}
        errors={formState.errors}
        maxLength={validations ? validations?.maxlength : null}
      />
    );
  }
  return <></>;
};

const renderContent = (data, control, formState) =>
  data.map((row, rowIndex) => {
    const className = classNames('o-grid__row', {
      [`u-mt-24`]: rowIndex === 0,
    });

    return (
      <div key={`o-grid__row-${rowIndex}`} className={className}>
        {row.map(({ col, type, required, placeholder, label, options, validations }, colIndex) => (
          <div key={`o-grid__col-${colIndex}`} className={`o-grid__col-${col}`}>
            {getFieldComponent({
              index: `${rowIndex}-${colIndex}`,
              type,
              required,
              placeholder,
              label,
              options,
              validations,
              control,
              formState,
            })}
          </div>
        ))}
      </div>
    );
  });

export default renderContent;
